<template lang="pug">
.hn
  //TAB區
  .hnTabBlock(v-if="tabs !== null")
    .hnTab(
      v-for="(item, index) in tabs"
      :key="item.id"
      @click="setTab(index)"
    ) {{ item.text }}

  div(
    v-for="(layer, layerIndex) in showLayerData"
    :class="`hnBlock${layerIndex+1}`"
  )
    router-link(
      v-for="(item, i) in layer"
      :key="item.id"
      :class="`hnPost${item._index}`"
      :to="{name: 'Post' ,params: {postid: item.id}}"
    )
      ImgLoader(
        :class="`hnPostPic${item._index}`"
        :img="item.cover_photo"
        :alt="'沒有圖片'"
        :style="{'--bgPos': 'center'}"
      )
      div(:class="`hnPostText${item._index}`")
        div(:class="`hnPostTitle${item._index}`") {{ item.title }}
        div(
          v-if="item.author"
          :class="`hnPostSubTitle${item._index}`"
        ) ➤ {{ item.author.name }}
        div(:class="`hnPostDate${item._index}`") {{ item.id.slice(0, 10) }}
        div(:class="`hnPostContent${item._index}`") {{ HtoS(item.body) }}
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  computed: {
    showLayerData() {
      if (this.tabs == null || this.tabs.length === 0) return []
      let list = this.tabs[this.tabIndex].data.slice(0,6)
      return list.reduce((acc, cur, i) => {
        cur._index = i+1
        const newListIndex = Math.floor(i / 2)
        acc[newListIndex] == null
          ? acc.push([cur])
          : acc[newListIndex].push(cur)
        return acc
      }, [])
    }
  },
  methods: {
    async setTab(index) {
      this.tabIndex = index
      // getTopArticles(item.id, 1)
    },
    HtoS(s) {
      return s.replace(/<(?:.|\s)*?>/g, "").replace(/&nbsp;/ig, "").replace(/&hellip;/ig, "").replace(/&mdash;/ig, "")
    },
  }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'
.hn
  width: 95%
  height: 45vw
  // +bb
  background: url('../assets/news1block.png')
  +bgcon
  background-position: 0 0
  background-size: 100% 100%
  margin-left: 2.5%
  //TAB區
  .hnTabBlock
    width: 100%
    height: 5.9%
    // +bb
    +flexrow
    justify-content: space-around
    align-items: center
    position: relative
    .hnTab
      position: relative
      font-size: 1vw
      cursor: pointer
      color: #878787
      font-weight: 800
      // width: 10%
      // height: 20%
      // +flexcolumn
      .hnTabTri
        position: absolute
        +size(0.7vw)
        background: url('../assets/HomeNews/smalltri.png')
        +bgcon
        left: 50%
        margin-left: -0.35vw
        display: none
        &.active
          // +size(500px)
          display: block


  //第一欄
  .hnBlock1
    width: 100%
    height: 22.4%
    box-sizing: border-box
    // +bb
    +flexrow
    //左
    .hnPost1
      width: 50%
      height: 100%
      box-sizing: border-box
      +flexrow
      padding: 2%
      .hnPostPic1
        +size(40%, 100%)
        margin-right: 5%
      .hnPostText1
        width: 50%
        height: 100%

        .hnPostTitle1
          height: 30%
          font-size: 0.9vw
          font-weight: 800
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            font-size: 1vw
            height: 36%
            letter-spacing: 0.1vw
        .hnPostSubTitle1
          height: 20%
          line-height: 1.6vw
          font-size: 0.8vw
          color: #878787
          overflow: hidden !important
          text-overflow: ellipsis !important
          white-space: nowrap !important
          +smallcom
            font-size: 1vw
            margin-top: 0.5vw

        .hnPostDate1
          height: 23%
          font-size: 0.8vw
          color: #A06F21
          +smallcom
            // font-size: 1vw
            margin-top: 0.5vw


        .hnPostContent1
          height: 28%
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            display: none

    //右
    .hnPost2
      width: 50%
      height: 100%
      box-sizing: border-box
      +flexrow
      padding: 2%
      .hnPostPic2
        +size(40%, 100%)
        margin-right: 5%
      .hnPostText2
        width: 50%
        height: 100%
        .hnPostTitle2
          height: 30%
          font-size: 0.9vw
          font-weight: 800
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            font-size: 1vw
            height: 36%
            letter-spacing: 0.1vw

        .hnPostSubTitle2
          height: 20%
          line-height: 1.6vw
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          +smallcom
            font-size: 1vw
            margin-top: 0.5vw
        .hnPostDate2
          height: 23%
          font-size: 0.8vw
          color: #A06F21
          +smallcom
            // font-size: 1vw
            margin-top: 0.5vw
        .hnPostContent2
          height: 28%
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            display: none
  //第二欄
  .hnBlock2
    width: 100%
    height: 44.8%
    box-sizing: border-box
    // +bb
    +flexrow
    //左
    .hnPost3
      width: 24.9%
      height: 100%
      box-sizing: border-box
      // +bb
      padding: 3%

      .hnPostPic3
        +size(100%, 45%)
        // +bb
      .hnPostText3
        height: 55%
        .hnPostTitle3
          height: 32%
          padding: 0.5vw 0 1vw 0
          box-sizing: border-box
          // line-height: 1.6vw
          font-size: 0.9vw
          font-weight: 800
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            font-size: 1vw
            height: 37%
            letter-spacing: 0.1vw
        .hnPostSubTitle3
          height: 26%
          // +bb
          line-height: 1.2vw
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            height: 31%
            font-size: 1vw
            margin-top: 0.5vw
            line-height: 1.5vw
        .hnPostDate3
          height: 19%
          font-size: 0.8vw
          color: #A06F21
          +smallcom
            margin-top: 0.5vw

        .hnPostContent3
          height: 24%
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            display: none
    //右
    .hnPost4
      width: 75.1%
      height: 100%
      box-sizing: border-box
      // +bb
      padding: 6%
      +flexrow

      .hnPostPic4
        +size(40%, 100%)
        margin-right: 5%
      .hnPostText4
        width: 55%
        .hnPostTitle4
          height: 23%
          padding: 0.5vw 0 1vw 0
          box-sizing: border-box
          // line-height: 1.6vw
          font-size: 0.9vw
          font-weight: 800
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +com
            font-size: 1vw
          +smallcom
            font-size: 1.3vw
            height: 28%
        .hnPostSubTitle4
          height: 18%
          // +bb
          line-height: 1.2vw
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +com
            line-height: 1.5vw
            height: 20%
          +smallcom
            height: 22%
            font-size: 1vw
            margin-top: 0.5vw
            line-height: 1.7vw
        .hnPostDate4
          height: 19%
          font-size: 0.8vw
          line-height: 30px
          color: #A06F21
        .hnPostContent4
          height: 25%
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          line-height: 1.2vw
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 3
          -webkit-box-orient: vertical
          +com
            height: 30%
            line-height: 1.5vw
          +smallcom
            height: 30%
            font-size: 1vw
            line-height: 2.1vw
            -webkit-line-clamp: 2


  //第三欄
  .hnBlock3
    width: 100%
    height: 22%
    box-sizing: border-box
    // +bb
    +flexrow
    //左
    .hnPost5
      width: 50%
      height: 100%
      box-sizing: border-box
      +flexrow
      padding: 2%
      // +bb
      .hnPostPic5
        +size(40%, 100%)
        margin-right: 5%
      .hnPostText5
        width: 50%
        height: 100%
        .hnPostTitle5
          height: 30%
          font-size: 0.9vw
          font-weight: 800
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            font-size: 1vw
            height: 40%
            letter-spacing: 0.1vw
        .hnPostSubTitle5
          height: 20%
          line-height: 1.6vw
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          +smallcom
            font-size: 1vw
            margin-top: 0.5vw
        .hnPostDate5
          height: 23%
          font-size: 0.8vw
          color: #A06F21
        .hnPostContent5
          height: 28%
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            display: none
    //右
    .hnPost6
      width: 50%
      height: 100%
      box-sizing: border-box
      +flexrow
      padding: 2%
      // +bb
      .hnPostPic6
        +size(40%, 100%)
        margin-right: 5%
      .hnPostText6
        width: 50%
        height: 100%
        .hnPostTitle6
          height: 30%
          font-size: 0.9vw
          font-weight: 800
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            font-size: 1vw
            height: 40%
            letter-spacing: 0.1vw
        .hnPostSubTitle6
          height: 20%
          line-height: 1.6vw
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          +smallcom
            font-size: 1vw
            margin-top: 0.5vw
        .hnPostDate6
          height: 23%
          font-size: 0.8vw
          color: #A06F21
        .hnPostContent6
          height: 28%
          font-size: 0.8vw
          color: #878787
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +smallcom
            display: none
</style>



// WEBPACK FOOTER //
// src/components/HomeNews.vue